import modalTemplateURL from 'ngtemplate-loader!./messageModal.tpl.html';

const name = 'messageModal'

export const template = modalTemplateURL;
export default class MessageModal {

  constructor($modalInstance, listClass, selected, Messages, $rootScope, BookingAPI, $scope, $timeout) {
    angular.extend(this, $modalInstance);
    this.form = listClass;
    this._tab = 'email';
    this._errors = [];
    this.bookings = listClass.selected;
    this.messages = Messages;
    this.rs = $rootScope;
    this.api = BookingAPI;
    this._templates = this.emailMessages()

    $scope.$watch(()=> this._tab, (n,o) => {
      this.templates = n;
    })
    
    $scope.$watch(() => this.selected, (n, o) => {
      if (this._tab === 'sms') this.message = n.template;
    })

  }

  set templates(type) {
    if (type === 'email') this._templates = this.emailMessages();
    if (type === 'sms') this._templates = this.smsMessages();
  }

  get templates() {
    return this._templates;
  }

  emailMessages() {
    return [].concat(this.confirmations, this.cancellations);
  }

  /**
   * REMINDER - Update these values over in `controller/reservations.js`
   */
  smsMessages() {
    return [
      {
        type: 'sms',
        template: `No Reply - {company.name} - Your flight has been cancelled due to weather. Call {company.phone} to rebook btw 9am-5pm daily.`,
        name: `Weather Cancellation`
      },
      {
        type: `sms`,
        template: `NO REPLY - {company.name} - We can’t wait to see you tomorrow morning at {pickup.time} @ {accommodations.hotel.name}. Please be ready a few minutes before your {pickup.time} pick up. If you have not already done so, be sure everyone in your party signs our Release: {waiverLink} For your convenience here is your confirmation with other important information - {confLink}. See you soon!`,
        name: 'Pick-Up Reminder'
      },
      { 
        type: `sms`,
        template: `No Reply - {company.name} - We can’t wait to see you tomorrow morning at the {company.description}. Please arrive a few minutes before {meetingTime} with waivers completed by everyone in your group. Our waiver can be signed here: {waiverLink}. Your confirmation with other important information can be viewed here: {confLink}. See you soon!`,
        name: `Booking Reminder`
      },
      {
        type: `sms`,
        template: `No Reply - {company.name} - Thank you for booking your hot air balloon ride with us on {day}. You have opted in to receive text message updates related to your reservation. Your confirmation number is {conf} - {confLink}. Please be sure everyone in your party signs our electronic waiver {waiverLink} before arriving on {day}. See you soon! Reply STOP to opt out.`,
        name: `Flight Confirmation`
      },
      {
        type: 'sms',
        template: 'No Reply - {company.name} - Thank you for booking with us. If you have not already done so, please help us make your morning run smooth by pre-signing our Release: {waiverLink}',
        name: 'Sign Waiver'
      },
      {
        type: `sms`,
        template: ``,
        name: `Custom Message`
      }
    ]
  }


  get user() {
    return this.rs.user;
  }

  get company() {
    return this.user.activeCompany()
  }

  get confirmations() {
    return [
      {
        type: 'confirmation',
        name: 'Resend Confirmation'
      }
    ];
  }

  get cancellations() {
    return this.company.cancellations.map((template) => {
      template.type = 'cancellation';
      return template;
    });
  }

  messageGroup(item) {
    switch (item.type) {
      case 'confirmation':
        return 'Confirmation Emails';
      case 'cancellation':
        return 'Cancellation Emails';
    }
  }

  bulkResend(ids) {
    const api = this.api.req();
    const data = {
      ids
    };
    this.working = true;
    return api.bulkResend(data).$promise.then(res => {
      this.working = false;
      return res;
    });
  }

  bulkCancel(ids) {
    const api = this.api.req();
    const cancel = this.bookings.map((booking) => {
      return booking.cancel(this.selected._id)
    });
    return Promise.all(cancel)
  }

  bulkSms(ids) {
    const api = this.api.req();
    this.working = true;
    const send = ids.map(id => {
      return api.sms({
        id,
        body: this.message
      })
    });
    return Promise.all(send)
  }

  set tab(tab) {
    this._tab = tab;
  }

  activeTab(tab) {
    if (tab === undefined) return this._tab;
    return this._tab === tab;
  }

  $onInit() {}

  done() {
    const selected = this.selected;
    if(this.activeTab('email')) {
      switch (selected.type) {
        case 'confirmation':
          if (selected.name === 'Resend Confirmation') {
            this.bulkResend(this.bookings.map(booking => booking._id)).then(res => {
              if (res.errors > 0) {
                console.log('errors were present', res.errors);
              } else {
                this.close({ res, selected })
              }
            })
          }
          break;
        case 'cancellation': {
          this.bulkCancel().then(res => {
            this.close({ res, selected });
          })
          break;
        }
        default:
          break;
      }
    } else {
      this.bulkSms(this.bookings.map(booking => booking._id)).then((res) => {
        this.close({ res, selected })
      })
    }
  }

  cancel() {
    this.dismiss({ $value: 'cancel' });
  }


}



// WEBPACK FOOTER //
// ./client/assets/scripts/modules/reservations/dayview/messageModal.js